<template>
  <div class="yx-datainit-buliding-page main-layout">
    <CCollapseItem>
      <template slot="title-left"> 校园建筑标识设置 </template>
      <template slot="body">
        <c-search
          v-model="pageParams"
          :searchItems="searchItems"
          @reset="refresh"
          @search="pageGet(true)"
        >
        </c-search>
      </template>
    </CCollapseItem>
    <el-card class="box-table box-bottom">
      <div slot="header" class="btn-group">
        <!-- 操作按钮 -->
        <div class="btn-left">
          <div class="opt-btn" title="新增" @click="goto('')">
            <i class="iconfont icon-add"></i>
          </div>
        </div>
        <!-- 右侧操作按钮 -->
        <table-btns
          :tableColumns="tableColumns"
          @tableColumnsChange="tableColumnsChange"
          @refresh="pageGet(true)"
        ></table-btns>
      </div>

      <c-table
        :data="pageData"
        :tableColumns="tableColumns"
        :pagination="pageParams"
        @change="pageGet"
        @selectionChange="selectionChange"
        v-loading="pageLoading"
        @edit="goto"
        @delete="pageDel"
      >
      </c-table>
    </el-card>
    <!-- 编辑弹框 -->
    <el-dialog
      :title="title"
      :visible.sync="dialogFormVisible"
      @close="handleDialogClose"
      :lock-scroll="false"
      :close-on-click-modal="false"
    >
      <div class="div-scroll" style="max-height: 550px; padding: 0 5%">
        <div v-loading="handleLoading">
          <c-form
            v-model="handleData"
            ref="cForm"
            :formRules="formRules"
            :formItems="formItems"
            @submit="submit"
            @resetFields="resetFields"
          >
            <template slot="custom">
              <el-form-item label="坐标选取">
                <el-button @click="handleGetLocation" type="primary"
                  >点击选取</el-button
                >
              </el-form-item>
            </template>
          </c-form>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="坐标选取"
      :visible.sync="dialogVisible"
      width="80%"
      :close-on-click-modal="false"
    >
      <div class="location-select">
        <div id="map" class="map-container"></div>
        <div class="search-container">
          <span class="input-item-text">请输入关键字</span>
          <input type="text" id="tipinput" class="input-item" />
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MapLoader from "@/libs/AMap.js";
import MPage from "@/mixins/MPage.js";
import MHandle from "@/mixins/MHandle.js";
import Configs from "./data/building";
import {
  getOrgOptions,
  getRoleOptions,
  getUserOptions,
  getLinkOptions,
} from "@/libs/searchSelect.js";
let mPage = MPage({
  pagePath: "/welcome-live/location/listPage",
  pageDelPath: "/welcome-live/location",
  pageDelsPath: "",
  pageParams: {},
});
let mHandle = MHandle({
  handleGetPath: "/welcome-live/location",
  handleInsertPath: "/welcome-live/location/save",
  handleUpdatePath: "/welcome-live/location/update",
  handleDownLoadPath: "",
  handleData: {},
});
export default {
  mixins: [mPage, mHandle],
  data() {
    let { searchItems, tableColumns, formItems, formRules } = Configs(this);
    return {
      SUCCESS_CODE: "",
      isFold: false,
      searchItems,
      tableColumns,
      formItems,
      formRules,
      idList: [],
      title: "",
      dialogFormVisible: false,
      defaultHandleData: {
        name: "",
        lng: "",
        lat: "",
        collegeId: "",
        address: "",
        idList: [],
        handlerIdList: [],
      },
      dialogVisible: false,
      marker: null,
    };
  },
  created() {
    this.map = null;
    this.auto = null;
    this.placeSearch = null;
    this.handleData = Object.assign({}, this.defaultHandleData);
    this.SUCCESS_CODE = this.$store.state.dic.SUCCESS_CODE;
    getOrgOptions(this, { type: "college" }, null, 2);
    getUserOptions(this, null, 4);
    getLinkOptions(this, null, 3);
  },
  beforeMount() {
    MapLoader();
  },
  mounted() {},
  methods: {
    goto(data) {
      this.handleData = Object.assign({}, this.defaultHandleData);
      this.dialogFormVisible = true;
      let id = data.id;
      if (id) {
        this.handleGet(id);
        this.title = "编辑点位信息";
      } else {
        this.title = "新增点位信息";
      }
    },
    selectionChange(data) {
      let idList = [];
      if (data.length) {
        data.forEach((item) => {
          idList.push(item.id);
        });
        this.idList = idList;
      }
    },
    handleDelBatch() {
      if (this.idList.length) {
        this.pageDels(this.idList);
      } else {
        this.$message({
          message: "请选择需要删除的数据！",
          type: "warning",
        });
      }
    },
    pageDelAfterFn() {
      this.idList = [];
      this.pageGet(true);
    },
    refresh() {
      this.pageParams = {};
      this.pageGet(true);
    },
    tableColumnsChange(data) {
      let self = this;
      self.tableColumns.forEach((item) => {
        if (data.indexOf(item.prop) == -1) {
          item.show = false;
        } else {
          item.show = true;
        }
      });
    },
    submit() {
      if (this.handleData.id) {
        this.handleUpdate();
      } else {
        this.handleInsert();
      }
    },
    handleAfterFn() {
      this.$refs.cForm.resetFields();
      this.dialogFormVisible = false;
      this.pageGet(true);
    },
    resetFields() {
      this.dialogFormVisible = false;
      this.marker = null;
    },
    handleDialogClose() {
      this.$refs.cForm.resetFields();
      this.marker = null;
    },
    // 地图初始化
    mapInit(lng, lat) {
      // console.log(lng, lat);
      let self = this;
      let map = new AMap.Map("map", {
        viewMode: "3D",
        zoom: 16,
        // pitch: 60,
      });
      AMap.plugin(["AMap.ToolBar"], function () {
        // 在图面添加工具条控件，工具条控件集成了缩放、平移、定位等功能按钮在内的组合控件
        map.addControl(
          new AMap.ToolBar({
            // 简易缩放模式，默认为 false
            liteStyle: true,
            position: "LB",
          })
        );
      });
      // 如果是编辑，有经纬度信息，则将地图中心点和marker标注出来
      if (lng && lat) {
        console.log("初始化点位信息");
        map.setCenter([lng, lat]);
        self.marker = new AMap.Marker({
          position: [lng, lat],
          map,
          draggable: true,
        });
        self.marker.on("dragging", function (e) {
          // console.log(e)
          self.handleData.lng = e.lnglat.lng;
          self.handleData.lat = e.lnglat.lat;
        });
      }
      //清空搜索框
      let inputObj = document.getElementById("tipinput");
      if (inputObj) inputObj.value = "";
      // 添加搜索控件
      this.auto = new AMap.Autocomplete({ input: "tipinput" });
      this.placeSearch = new AMap.PlaceSearch({
        map: map,
      }); //构造地点查询类
      AMap.event.addListener(this.auto, "select", this.select); //注册监听，当选中某条记录时会触发

      map.on("click", function (e) {
        // console.log(e);
        console.log(self.marker);
        if (self.marker) {
          self.marker.setPosition([e.lnglat.lng, e.lnglat.lat]);
        } else {
          self.marker = new AMap.Marker({
            position: [e.lnglat.lng, e.lnglat.lat],
            map,
            draggable: true,
          });
          self.marker.on("dragging", function (e) {
            // console.log(e)
            self.handleData.lng = e.lnglat.lng;
            self.handleData.lat = e.lnglat.lat;
          });
        }
        // 更新点位信息
        self.handleData.lng = e.lnglat.lng;
        self.handleData.lat = e.lnglat.lat;
      });

      self.map = map;
    },
    select(e) {
      // console.log(e);
      this.placeSearch.setCity(e.poi.adcode);
      this.placeSearch.search(e.poi.name); //关键字查询查询
    },
    // 打开地图选点
    handleGetLocation() {
      console.log("选取坐标");
      this.dialogVisible = true;
      this.$nextTick(() => {
        if (this.handleData.lng && this.handleData.lat) {
          this.mapInit(this.handleData.lng, this.handleData.lat);
        } else {
          this.mapInit();
        }
      });
    },
  },
};
</script>


